import { createContext } from 'react';
import EditIPConfigContext from 'types/contexts/EditIPConfigContext';

export default createContext({} as EditIPConfigContext);
